import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { inviteMultipleUsers } from '@spectee/graphql/mutations';

const document = gql(inviteMultipleUsers);

export function useInviteMultipleUsers() {
  return useMutation(document);
}
